import { Props, CheckboxOption } from "./interfaces";
import classNames from "classnames";
import { useEffect, useRef } from "react";

export const CheckboxList = ({
  id,
  input,
  meta,
  options,
  label,
  isLabelHidden,
  setFieldRef,
  classes,
}: Props): JSX.Element => {
  const ref = useRef(null);

  useEffect(() => {
    setFieldRef(id, ref);
  }, []);

  const generatedClasses = {
    wrapper: classNames(
      "c-checkbox-list u-m-0 u-p-0 u-border-none",
      classes?.wrapper
    ),
    legend: classNames("c-label u-block u-mb-1", classes?.legend, {
      ["u-sr-only"]: isLabelHidden,
    }),
    optionsWrapper: classNames(classes?.optionsWrapper),
    optionWrapper: classNames(
      "u-flex u-items-center u-mb-2",
      classes?.optionWrapper
    ),
    optionLabel: classNames("c-label u-ml-2", classes?.optionLabel),
    optionInput: classNames(
      "c-input-text u-inline-block u-font-family-bold u-w-6 u-h-6",
      classes?.optionInput
    ),
  };

  const currentValue = input.value || [];

  const handleChange = (optionValue: string) => {
    const newValue = currentValue.includes(optionValue)
      ? currentValue.filter((v: string) => v !== optionValue)
      : [...currentValue, optionValue];
    input.onChange(newValue);
  };

  const renderOptions = (options: Array<CheckboxOption>) => {
    return options?.map((option, index: number) => {
      const { value, displayText, disabled } = option;
      const optionId = `${id}-${value}`;
      const isChecked = currentValue.includes(value);

      return (
        <div key={index} className={generatedClasses.optionWrapper}>
          <input
            type="checkbox"
            id={optionId}
            name={input.name}
            value={value}
            checked={isChecked}
            disabled={disabled}
            onChange={() => handleChange(value)}
            className={generatedClasses.optionInput}
          />
          <label htmlFor={optionId} className={generatedClasses.optionLabel}>
            {displayText}
          </label>
        </div>
      );
    });
  };

  return (
    <fieldset ref={ref} className={generatedClasses.wrapper}>
      <legend className={generatedClasses.legend}>{label}</legend>
      <div className={generatedClasses.optionsWrapper}>
        {renderOptions(options)}
      </div>
    </fieldset>
  );
};
